module.exports = __webpack_public_path__ + "img/3dvisionscanner.6cbfb76d.jpg";